var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowGrayBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_6330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74979 14.1668C8.64011 14.1674 8.5314 14.1464 8.42986 14.105C8.32833 14.0635 8.23599 14.0024 8.15812 13.9251C8.08001 13.8477 8.01802 13.7555 7.97571 13.654C7.9334 13.5524 7.91162 13.4435 7.91162 13.3335C7.91162 13.2235 7.9334 13.1145 7.97571 13.013C8.01802 12.9114 8.08001 12.8193 8.15812 12.7418L10.9165 10.0001L8.26645 7.24181C8.11124 7.08568 8.02413 6.87447 8.02413 6.65431C8.02413 6.43416 8.11124 6.22295 8.26645 6.06681C8.34392 5.9887 8.43609 5.92671 8.53764 5.8844C8.63919 5.84209 8.74811 5.82031 8.85812 5.82031C8.96813 5.82031 9.07705 5.84209 9.1786 5.8844C9.28015 5.92671 9.37232 5.9887 9.44979 6.06681L12.6665 9.40014C12.8191 9.55592 12.9047 9.76535 12.9047 9.98348C12.9047 10.2016 12.8191 10.411 12.6665 10.5668L9.33312 13.9001C9.25832 13.9809 9.16826 14.0461 9.06814 14.0918C8.96801 14.1376 8.85981 14.1631 8.74979 14.1668Z",
    fill: "#C2C4C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_6330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowGrayBold);
export default __webpack_public_path__ + "static/media/icon_arrow_gray_bold.234428543c75b799c4d12f9fcb6b353c.svg";
export { ForwardRef as ReactComponent };